/**
 * This route is dynamically added to the app if this section is
 * enabled inside the config for the tenant being built.
 */
// @ngInject
function states($stateProvider) {
  $stateProvider.state('skylight-checks', {
    parent: 'root',
    url: '/skylight-checks',
    templateUrl: 'apps/paycard-checks/templates/acp-paycard-checks.ng.html',
    controller: 'AcpPaycardChecksCtrl',
    resolve: {
      module: /* @ngInject */ function($ocLazyLoad) {
        return import(/* webpackChunkName: "acp.section.paycard-checks" */ 'apps/paycard-checks').then(
          $ocLazyLoad.loadModule
        );
      }
    }
  });
}

export default states;
